import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalFeedbackBannerComponent } from './components/global-feedback-banner/global-feedback-banner.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GlobalFeedbackBannerComponent, ToastContainerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}

